import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { StatCard, Card, CardHeader, CardTitle, CardContent, PageLoading } from "@dosa/ui";
import { getBusinessKpis, getClinicalKpis } from "../../lib/api-client";

export function AdminKpisPage() {
  const { t } = useTranslation();
  const { data: business, isLoading: bLoading } = useQuery({ queryKey: ["business-kpis"], queryFn: getBusinessKpis });
  const { data: clinical, isLoading: cLoading } = useQuery({ queryKey: ["clinical-kpis"], queryFn: getClinicalKpis });

  if (bLoading || cLoading || !business || !clinical) return <PageLoading />;

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-semibold text-charcoal-900">{t("admin.kpis.title")}</h1>

      <div>
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-charcoal-400">{t("admin.kpis.title")}</h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          <StatCard label={t("admin.kpis.totalPatients")} value={business.totalPatients} />
          <StatCard label={t("admin.kpis.totalPharmacists")} value={business.totalPharmacists} />
          <StatCard label={t("admin.kpis.appointmentsThisMonth")} value={business.appointmentsThisMonth} />
          <StatCard label={t("admin.kpis.completedAssessments")} value={business.completedMtmAssessmentsThisMonth} />
        </div>
      </div>

      <div>
        <h2 className="mb-3 text-sm font-semibold uppercase tracking-wide text-charcoal-400">{t("pharmacist.kpi.title")}</h2>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          <StatCard label={t("pharmacist.kpi.openMrps")} value={clinical.openMrpCount} />
          <StatCard label={t("pharmacist.kpi.interventionsThisMonth")} value={clinical.interventionsThisMonth} />
          <StatCard label={t("pharmacist.kpi.followUpsOverdue")} value={clinical.followUpsOverdue} />
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>MRPs by category</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-3 sm:grid-cols-4">
          {Object.entries(clinical.mrpsByCategory).map(([category, count]) => (
            <div key={category} className="rounded-md border border-charcoal-100 p-3 text-center">
              <p className="text-2xl font-semibold text-charcoal-800">{count}</p>
              <p className="text-xs text-charcoal-400">{t(`pharmacist.mrp.categories.${category}`)}</p>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
